import { getChannelIdFromSettingsURL, getTeamIdFromURL } from '@/_helpers';
import TeamDashboard from './Team';
import ChannelDashboard from '../Dashboard/Channel';
const Dashboard = () => {
    const channelId = getChannelIdFromSettingsURL();
    const teamId = getTeamIdFromURL();
    if (!channelId && !teamId) {
        return <div>Loading Dashboard...</div>;
    }
    if (channelId) {
        return <ChannelDashboard />;
    }
    return <TeamDashboard />;
};

export default Dashboard;
